define("shared/types/youtube", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.YoutubePrivacyStatus = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * For Youtube Category Response types:
   * @see https://developers.google.com/youtube/v3/docs/videoCategories/list
   *
   */
  let YoutubePrivacyStatus = _exports.YoutubePrivacyStatus = /*#__PURE__*/function (YoutubePrivacyStatus) {
    YoutubePrivacyStatus["Private"] = "private";
    YoutubePrivacyStatus["Public"] = "public";
    YoutubePrivacyStatus["Unlisted"] = "unlisted";
    return YoutubePrivacyStatus;
  }({});
});